import { render, staticRenderFns } from "./ReportFull.vue?vue&type=template&id=c2e1d6a6&scoped=true&"
import script from "./ReportFull.vue?vue&type=script&lang=js&"
export * from "./ReportFull.vue?vue&type=script&lang=js&"
import style0 from "./ReportFull.vue?vue&type=style&index=0&id=c2e1d6a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e1d6a6",
  null
  
)

export default component.exports